/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { SDKError } from "./sdkerror.js";

/**
 * Rate limited
 */
export type RegenerateScopedApiKeyAuthApiKeysResponse429ResponseBodyData = {
  message: string;
};

/**
 * Rate limited
 */
export class RegenerateScopedApiKeyAuthApiKeysResponse429ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: RegenerateScopedApiKeyAuthApiKeysResponse429ResponseBodyData;

  constructor(
    err: RegenerateScopedApiKeyAuthApiKeysResponse429ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "RegenerateScopedApiKeyAuthApiKeysResponse429ResponseBody";
  }
}

/**
 * Conflict
 */
export type RegenerateScopedApiKeyAuthApiKeysResponse409ResponseBodyData = {
  message: string;
};

/**
 * Conflict
 */
export class RegenerateScopedApiKeyAuthApiKeysResponse409ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: RegenerateScopedApiKeyAuthApiKeysResponse409ResponseBodyData;

  constructor(
    err: RegenerateScopedApiKeyAuthApiKeysResponse409ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "RegenerateScopedApiKeyAuthApiKeysResponse409ResponseBody";
  }
}

/**
 * Not found
 */
export type RegenerateScopedApiKeyAuthApiKeysResponse404ResponseBodyData = {
  message: string;
};

/**
 * Not found
 */
export class RegenerateScopedApiKeyAuthApiKeysResponse404ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: RegenerateScopedApiKeyAuthApiKeysResponse404ResponseBodyData;

  constructor(
    err: RegenerateScopedApiKeyAuthApiKeysResponse404ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "RegenerateScopedApiKeyAuthApiKeysResponse404ResponseBody";
  }
}

/**
 * Forbidden
 */
export type RegenerateScopedApiKeyAuthApiKeysResponseResponseBodyData = {
  message: string;
};

/**
 * Forbidden
 */
export class RegenerateScopedApiKeyAuthApiKeysResponseResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: RegenerateScopedApiKeyAuthApiKeysResponseResponseBodyData;

  constructor(
    err: RegenerateScopedApiKeyAuthApiKeysResponseResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "RegenerateScopedApiKeyAuthApiKeysResponseResponseBody";
  }
}

/**
 * Unauthorized
 */
export type RegenerateScopedApiKeyAuthApiKeysResponseBodyData = {
  message: string;
};

/**
 * Unauthorized
 */
export class RegenerateScopedApiKeyAuthApiKeysResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: RegenerateScopedApiKeyAuthApiKeysResponseBodyData;

  constructor(
    err: RegenerateScopedApiKeyAuthApiKeysResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "RegenerateScopedApiKeyAuthApiKeysResponseBody";
  }
}

/**
 * Bad request
 */
export type RegenerateScopedApiKeyResponseBodyData = {
  message: string;
};

/**
 * Bad request
 */
export class RegenerateScopedApiKeyResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: RegenerateScopedApiKeyResponseBodyData;

  constructor(
    err: RegenerateScopedApiKeyResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "RegenerateScopedApiKeyResponseBody";
  }
}

/** @internal */
export const RegenerateScopedApiKeyAuthApiKeysResponse429ResponseBody$inboundSchema:
  z.ZodType<
    RegenerateScopedApiKeyAuthApiKeysResponse429ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new RegenerateScopedApiKeyAuthApiKeysResponse429ResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type RegenerateScopedApiKeyAuthApiKeysResponse429ResponseBody$Outbound =
  {
    message: string;
  };

/** @internal */
export const RegenerateScopedApiKeyAuthApiKeysResponse429ResponseBody$outboundSchema:
  z.ZodType<
    RegenerateScopedApiKeyAuthApiKeysResponse429ResponseBody$Outbound,
    z.ZodTypeDef,
    RegenerateScopedApiKeyAuthApiKeysResponse429ResponseBody
  > = z.instanceof(RegenerateScopedApiKeyAuthApiKeysResponse429ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const RegenerateScopedApiKeyAuthApiKeysResponse409ResponseBody$inboundSchema:
  z.ZodType<
    RegenerateScopedApiKeyAuthApiKeysResponse409ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new RegenerateScopedApiKeyAuthApiKeysResponse409ResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type RegenerateScopedApiKeyAuthApiKeysResponse409ResponseBody$Outbound =
  {
    message: string;
  };

/** @internal */
export const RegenerateScopedApiKeyAuthApiKeysResponse409ResponseBody$outboundSchema:
  z.ZodType<
    RegenerateScopedApiKeyAuthApiKeysResponse409ResponseBody$Outbound,
    z.ZodTypeDef,
    RegenerateScopedApiKeyAuthApiKeysResponse409ResponseBody
  > = z.instanceof(RegenerateScopedApiKeyAuthApiKeysResponse409ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const RegenerateScopedApiKeyAuthApiKeysResponse404ResponseBody$inboundSchema:
  z.ZodType<
    RegenerateScopedApiKeyAuthApiKeysResponse404ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new RegenerateScopedApiKeyAuthApiKeysResponse404ResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type RegenerateScopedApiKeyAuthApiKeysResponse404ResponseBody$Outbound =
  {
    message: string;
  };

/** @internal */
export const RegenerateScopedApiKeyAuthApiKeysResponse404ResponseBody$outboundSchema:
  z.ZodType<
    RegenerateScopedApiKeyAuthApiKeysResponse404ResponseBody$Outbound,
    z.ZodTypeDef,
    RegenerateScopedApiKeyAuthApiKeysResponse404ResponseBody
  > = z.instanceof(RegenerateScopedApiKeyAuthApiKeysResponse404ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const RegenerateScopedApiKeyAuthApiKeysResponseResponseBody$inboundSchema:
  z.ZodType<
    RegenerateScopedApiKeyAuthApiKeysResponseResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new RegenerateScopedApiKeyAuthApiKeysResponseResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type RegenerateScopedApiKeyAuthApiKeysResponseResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const RegenerateScopedApiKeyAuthApiKeysResponseResponseBody$outboundSchema:
  z.ZodType<
    RegenerateScopedApiKeyAuthApiKeysResponseResponseBody$Outbound,
    z.ZodTypeDef,
    RegenerateScopedApiKeyAuthApiKeysResponseResponseBody
  > = z.instanceof(RegenerateScopedApiKeyAuthApiKeysResponseResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const RegenerateScopedApiKeyAuthApiKeysResponseBody$inboundSchema:
  z.ZodType<
    RegenerateScopedApiKeyAuthApiKeysResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new RegenerateScopedApiKeyAuthApiKeysResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type RegenerateScopedApiKeyAuthApiKeysResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const RegenerateScopedApiKeyAuthApiKeysResponseBody$outboundSchema:
  z.ZodType<
    RegenerateScopedApiKeyAuthApiKeysResponseBody$Outbound,
    z.ZodTypeDef,
    RegenerateScopedApiKeyAuthApiKeysResponseBody
  > = z.instanceof(RegenerateScopedApiKeyAuthApiKeysResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const RegenerateScopedApiKeyResponseBody$inboundSchema: z.ZodType<
  RegenerateScopedApiKeyResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new RegenerateScopedApiKeyResponseBody(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type RegenerateScopedApiKeyResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const RegenerateScopedApiKeyResponseBody$outboundSchema: z.ZodType<
  RegenerateScopedApiKeyResponseBody$Outbound,
  z.ZodTypeDef,
  RegenerateScopedApiKeyResponseBody
> = z.instanceof(RegenerateScopedApiKeyResponseBody)
  .transform(v => v.data$)
  .pipe(z.object({
    message: z.string(),
  }));
